/**
 * Created by yz on 2017/3/22.
 */

//css
// require('../lib/bootstrap-3.3.7/css/bootstrap.css');
require('../lib/bootstrap-3.3.7/css/bootstrap.min.css');       //另一个地方index.html有，应该可以删除index.html这个
// require('../lib/font-awesome-4.7.0/css/font-awesome.min.css');
// require('../lib/idangerous.swiper/idangerous.swiper.css');

require('../css/style.css');


 //js
require('../lib/angular-1.6.3/angular.min');
require('../lib/angular-ui-router');
require('../lib/angular-1.6.3/angular-sanitize.min');//2017.8.24 cl加
// require('../lib/1.5.8/angular');
// require('../lib/ui-router/angular-ui-router.min');
// require('../lib/jquery-1.12.4');
// require('../lib/bootstrap-3.3.7/js/bootstrap');
require('../lib/bootstrap-3.3.7/js/bootstrap.min');
require('../lib/angular-md5');

require('../lib/angular-file-upload');  //上传文件的angularjs插件
require('../lib/date');       //这个是什么东西？？
// require('../lib/idangerous.swiper/idangerous.swiper.js');
// require('../lib/angular-swiper');

//
require('./app.module');
require('./service/data/requestHandler.service');
require('./service/data/login.service');
require('./service/data/file.service');
require('./service/data/order.service');
require('./service/utils/constant');
require('./service/utils/uploadManager');
require('./service/utils/currentUser');
require('./service/utils/modalWindow/modalWindow');
require('./service/utils/alertControl/alertControl');
require('./service/utils/common');
require('./service/utils/platform');
require('./service/utils/refundUploadManager');
require('./service/utils/uploadImageManager');//新增0922
require('./service/utils/global');
require('./directives/datePlugin/datePlugin');  //日期选择器脚本

require('./directives/swiper/swiper.directive.js');

require('./filters/filters');

require('./views/main.controller');
require('./views/login.controller');
require('./views/header.controller');
require('./views/content/home.controller');
require('./views/content/uploading.controller');
require('./views/content/printSettings.controller');
require('./views/content/pay.controller');
//require('./views/content/pay.controller');
require('./views/content/paySuccess.controller');
require('./views/content/order.controller');
require('./views/content/orderDetail.controller');
require('./views/content/user.controller');
require('./views/content/refund.controller');
require('./views/content/refundDetail.controller');
require('./views/content/orderDetail.controller');
require('./views/content/preview.controller');
require('./views/modals/qrpayModal.controller');
require('./views/modals/qruserModal.controller');
require('./views/modals/checkRechargeTransidModal.controller');  //新增20171222
//require('./views/modals/rechargeModal.controller');
require('./views/content/useProcess.controller');
require('./views/content/aboutUs.controller');
require('./views/content/contactUs.controller');
//新增
require('./views/content/recharge.controller');
require('./views/content/company.controller');
require('./views/content/partner.controller');
require('./views/content/proclamation.controller');

require('./views/modals/advertising.controller');
require('./views/content/machineTip.controller');
require('./views/content/uploadImage.controller');

require('./views/content/rechargeRecord.controller');
require('./views/content/stationMap.controller');




